var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('a-card',{attrs:{"tabList":_vm.tabList,"activeTabKey":_vm.currentTab},on:{"tabChange":_vm.tabChange}},[(_vm.currentTab == 'maintenance_task')?_c('MaintenanceTask'):_vm._e(),(_vm.currentTab == 'maintenance_record')?_c('MaintenanceRecord'):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }